import { useMemo } from 'react';

import { useQuery } from '@apollo/client';

import FullUserInfo from '@/graphql/FullUserInfo';
import { useAuth } from '@/hooks/auth/use-auth';
import { useCommonApolloOptions } from '@/hooks/use-common-apollo-options';
import { isDefined } from '@/utils/utils';

export function useFullUserInfo() {
  const apolloOptions = useCommonApolloOptions();

  const { check_access } = useAuth();

  const userInfo = check_access();

  const userId = userInfo ? userInfo.hasura['x-hasura-user-id'] : undefined;
  const parsedUserIdNumber = isDefined(userId) ? Number(userId) : undefined;
  const userIdNumber =
    isDefined(parsedUserIdNumber) && !Number.isNaN(parsedUserIdNumber) ? parsedUserIdNumber : undefined;

  const query = useQuery(FullUserInfo, {
    ...apolloOptions,
    variables: {
      user_id: userIdNumber,
    },
  });

  const data = useMemo(() => {
    if (!query.data) {
      return null;
    }

    const user = query.data.user_info.at(0);
    const merchant = query.data.merchant_user.at(0);

    return {
      userInfo: user && {
        id: userIdNumber,
        email: user.email,
        name: user.name,
      },
      merchantInfo: merchant && {
        id: merchant.merchant_id,
      },
    };
  }, [query.data, userIdNumber]);

  return {
    ...query,
    data,
  };
}
